import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGetAllEventState, IListActiveEvent } from '../../actions/types/events/GetAllEventListTypes';

/**
 * Initial All Event state in store
 */
const initialState: IGetAllEventState = {
  isLoading: false,
  eventErrorMessage: '',
  events: {
    currentPageNumber: 0,
    numberOfRecordsPerPage: 10,
    totalRecords: 0,
    numberOfPages: 0,
    events: [
      {
        uuid: '',
        status: '',
        version: '',
        createdBy: '',
        createdTimestamp: '',
        updatedBy: '',
        updatedTimestamp: '',
        eventName: '',
        eventDescription: '',
        eventType: '',
        eventCategory: '',
        eventSchemaId: '',
        dataEncryption: false,
        sensitiveFields: [],
        eventSchemaVersion: '',
        eventStatusHistory: []
      }
    ]
  }
};

const fetchEventListSlice = createSlice({
  name: 'fetchEventList',
  initialState,
  reducers: {
    fetchEventListStarted: (state) => {
      state.isLoading = true;
    },

    fetchEventListSuccess: (state, action: PayloadAction<IListActiveEvent>) => {
      state.isLoading = false;
      state.events = action.payload;
      state.eventErrorMessage = '';
    },

    fetchEventListFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.events = initialState.events;
      state.eventErrorMessage = action.payload;
    },

    clearEventListDetails: (state) => {
      state.isLoading = false;
      state.events = initialState.events;
      state.eventErrorMessage = '';
    }
  }
});
export const {
  fetchEventListStarted,
  fetchEventListSuccess,
  fetchEventListFail,
  clearEventListDetails
} = fetchEventListSlice.actions;
export default fetchEventListSlice.reducer;
